import type { ChangeEventHandler, ReactNode } from "react";
import type { RegisterOptions } from "react-hook-form";
import { Controller, useFormContext } from "react-hook-form";

import {
  CheckboxItem,
  type CheckboxItemProps,
  type Option,
} from "@/react/components/SettingsApp/CompassCompat/Checkbox";

export interface CheckboxProps extends Omit<
  CheckboxItemProps,
  "option" | "checked" | "onChange"
> {
  checked?: boolean;
  description?: ReactNode;
  label?: ReactNode;
  name: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  option?: Option;
  rules?: RegisterOptions;
}

export const Checkbox = ({
  name,
  rules,
  label = "",
  description = "",
  ...rest
}: CheckboxProps) => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <CheckboxItem
          onChange={event => onChange(event.target.checked)}
          checked={value}
          option={{ label, description }}
          invalid={!!error}
          error={error?.message}
          {...rest}
        />
      )}
    />
  );
};

Checkbox.displayName = "Form.Checkbox";
